// The staff pages inside Pro's frame, or Simple's: `studio2`'s frame around them, under the team and
// brand the tab was last on, whenever their URL's `?ui=` names Pro or Simple (spec
// ui-perf/admin-panel-pro-simple). Platform draws every `staticData.teamFrame` page in it, and
// cannot import a feature, so the composition root gives it (`ProFrameProvider`, in `App`).
import { ProPage } from "../features/studio2/ProPage";
import { ProShell } from "../features/studio2/Studio2Shell";
import type { ProFrame } from "../platform/ui-switch/frame";

/** A page with no team of its own as a Pro page: Pro's header, its nav but on Simple, its padding. */
export const proStaffFrame: ProFrame = ({ teamId, brandId, simple, children }) => (
  <ProShell teamId={teamId} brandId={brandId} simple={simple}>
    <ProPage>{children}</ProPage>
  </ProShell>
);
